
export default {
  name: 'AppFeatureItem',
  props: {
    image: { type: String, default: '' },
    title: { type: String, default: '' },
    en: { type: String, default: '' },
  },
};
